export default {
    component: () => import(/* webpackChunkName: "dashboard-layout" */ '@/modules/dashboard/layouts/DashboardLayout.vue'),
    children: [
        {
            path: '',
            name: 'dashboard',
            component: () => import(/* webpackChunkName: "dashboard-view" */ '@/modules/dashboard/views/DashboardView.vue'),
        }
    ]
}